import styled, { keyframes } from "styled-components";

import {
  BREAKPOINTS,
  FONT_SIZES,
  SPACING,
  TOUCH_TARGET,
} from "../../../../../utils/constants";
import Button from "../../../../../components/Button";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Notice = styled.div<{ $isRetrying: boolean }>`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: ${SPACING.sm + SPACING.xxs}px;
  padding: ${SPACING.sm + SPACING.xxs}px ${SPACING.sm + SPACING.xs}px;
  border: 1px solid
    ${({ $isRetrying }) =>
      $isRetrying
        ? "color-mix(in srgb, var(--color-primary) 36%, var(--color-card-border))"
        : "var(--color-error-border)"};
  border-radius: 8px;
  background: ${({ $isRetrying }) =>
    $isRetrying
      ? "color-mix(in srgb, var(--color-primary) 8%, var(--color-card-background))"
      : "var(--color-error-background)"};
  font-family: inherit;

  > svg,
  > span {
    color: ${({ $isRetrying }) =>
      $isRetrying ? "var(--color-primary)" : "var(--color-error)"};
  }

  strong {
    display: block;
    color: var(--color-text-default);
    font-size: ${FONT_SIZES.sm};
    line-height: 1.25;
  }

  p {
    max-width: 70ch;
    margin: ${SPACING.xxs}px 0 0;
    color: var(--color-text-secondary);
    font-size: ${FONT_SIZES.xs};
    line-height: 1.4;
  }

  @media (max-width: ${BREAKPOINTS.tabletMin}px) {
    grid-template-columns: auto minmax(0, 1fr);
    align-items: start;
  }
`;

export const SpinningIcon = styled.span`
  display: inline-flex;
  animation: ${spin} 800ms linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const RetryButton = styled(Button)`
  @media (max-width: ${BREAKPOINTS.tabletMin}px) {
    grid-column: 1 / -1;
    min-height: ${TOUCH_TARGET}px;
  }
`;
